module.exports = __webpack_public_path__ + "static/media/mars-awakens-1.67a25431.jpg";